import { render, staticRenderFns } from "./fish-list.vue?vue&type=template&id=e143263a&scoped=true"
import script from "./fish-list.vue?vue&type=script&lang=js"
export * from "./fish-list.vue?vue&type=script&lang=js"
import style0 from "./fish-list.vue?vue&type=style&index=0&id=e143263a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e143263a",
  null
  
)

export default component.exports